import { render } from "./Etapes.vue?vue&type=template&id=0dc82998"
import script from "./Etapes.vue?vue&type=script&lang=js"
export * from "./Etapes.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__